// src/components/Hero.js
import React, { useState } from 'react';
import './Hero.css';
import noise from '../Assets/noise.png';

const Hero = () => {

    return (
        <div className="hero-container" id="home">
            <div className="hero-blob hero-blob-1"></div>
            <div className="hero-blob hero-blob-2"></div>
            <div className="hero-glow"></div>

            <div className="hero-content">
                <h1 className="hero-title">
                    Empower Your Business <br /> with <span>Cutting-Edge IT Solutions</span>
                </h1>
                <p className="hero-subtitle">
                    Tailored consulting to innovate, optimize, and grow your digital presence.
                </p>
                <a href="#contact" className="hero-btn">
                    Get in Touch
                </a>
            </div>

            <div className="hero-dot hero-dot-1"></div>
            <div className="hero-dot hero-dot-2"></div>
            <div className="hero-dot hero-dot-3"></div>
            <div className="hero-dot hero-dot-4"></div>
        </div>
    );
};

export default Hero;
